import React from 'react';
import { FiInfo } from 'react-icons/fi';
import roullete from './img/roullete.svg';
import moment from 'moment';
import { ChallengeBanner, ChallengeBannerBg, ChallengeBannerBody, ChallengeBannerCount, ChallengeBannerDate, ChallengeBannerFooter, ChallengeBannerHeader, ChallengeBannerTitle } from '@/components/custom/challenge';
import { CardProgressWrapper } from '@/components/ui/card';

export function WeekChallengeBanner({ challenges, isLoading }) {
  const initialDate = challenges?.[0]?.['initial-date']?.split('-').reverse().join('/');
  const endDate = challenges?.[0]?.['end-date']?.split('-').reverse().join('/');

  const challengesDone = challenges?.filter(item => item.done)?.length;
  const allChallenges = challenges?.length;

  const percentage = (100 * challengesDone) / allChallenges;

  const now = moment(moment().format('YYYY-MM-DD'));
  const deadline = moment(challenges?.[0]?.['end-date']);

  const DaysLeft = deadline.diff(now, 'days');

  return (
    <ChallengeBanner>
      <ChallengeBannerBg img={roullete} />

      <ChallengeBannerHeader>
        <ChallengeBannerTitle>Desafio da Semana</ChallengeBannerTitle>
        {initialDate && endDate && (
          <ChallengeBannerDate>
            De {initialDate} a {endDate}
          </ChallengeBannerDate>
        )}
      </ChallengeBannerHeader>

      <ChallengeBannerBody>
        {!isNaN(percentage) && (
          <CardProgressWrapper
            variant="cover"
            percentage={percentage}
            toFixed={2}
          />
        )}
      </ChallengeBannerBody>

      <ChallengeBannerFooter>
        <ChallengeBannerCount>
          <FiInfo /> Restam {DaysLeft} dias
        </ChallengeBannerCount>
      </ChallengeBannerFooter>
    </ChallengeBanner>
  );
}
